import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  IBillingAccount,
  IBillingDocument,
  IOdbBillProductSplit,
} from '@dch/billing-business-logic';
import { ODB_THIRD_PARTY_L3_PAGE } from '../../config/my-bill.constants';
import { ISelectedThirdPartyProductSplitInfo } from '../../models/pii.model';
import {
  ODB_THIRD_PARTY_L3_PAGE_SESSION_DATA_KEY,
  UtilsService,
} from '../../services/utils.service';

@Component({
  selector: 'my-bill-odb-third-party-product-split',
  templateUrl: './odb-third-party-product-split.component.html',
  standalone: false,
})
export class OdbThirdPartyProductSplitComponent {
  @Input() productSplit: Array<IOdbBillProductSplit>;
  @Input() totalAmount: string;
  @Input() billingAccount?: IBillingAccount;
  @Input() billingDocument?: IBillingDocument;
  @Input() openTransactionToPayIndex?: number;
  @Input() customerId?: number;
  @Input() customerGlobalId?: string;
  @Input() customerSubsegment?: string;
  @Input() customerMobile?: string;

  constructor(private router: Router, private utilsService: UtilsService) {}

  navigateToL3(aProductSplit: IOdbBillProductSplit) {
    this.utilsService.setValueInSessionStorage<ISelectedThirdPartyProductSplitInfo>(
      ODB_THIRD_PARTY_L3_PAGE_SESSION_DATA_KEY,
      {
        billingAccount: this.billingAccount,
        billDocument: this.billingDocument,
        openTransactionToPayIndex: this.openTransactionToPayIndex,
        selectedProductSplit: aProductSplit,
        customerId: this.customerId,
        customerSubsegment: this.customerSubsegment,
        customerGlobalId: this.customerGlobalId,
        customerMobile: this.customerMobile,
      }
    );
    this.router.navigate([ODB_THIRD_PARTY_L3_PAGE]);
  }
}
